import { useBaseStore } from '@/stores/BaseStore';
import axios from "axios";
import config from "@/composables/Config";
import {setToken} from "@/Helper";

export default function setupAuthSubscriber() {
    const baseStore = useBaseStore();

    baseStore.$onAction(({ name, store, args, after, onError }) => {
        if (name === "setToken") {
            after(() => {
                if(args[0]){
                    setToken(args[0]);
                }else {
                    axios.defaults.headers.common['Authorization'] = null;
                    baseStore.$patch((state) => {
                        state.user = null;
                        state.token = null;
                    });
                }
            });
            onError((error) => {
                console.log("Hello error: ", error.message);
                axios.defaults.headers.common['Authorization'] = null;
                baseStore.$patch((state) => {
                    state.user = null;
                    state.token = null;
                });
            });
        }
    });
}
